export const LOAD_SUBMISSION = 'LOAD_SUBMISSION'
export const GET_ONE_SUBMISSION = 'GET_ONE_SUBMISSION'
export const UPDATE_SUBMISSION = 'UPDATE_SUBMISSION'
